// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-warning-module__modal___s502s {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/components/general/content-warning/content-warning.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;AACF","sourcesContent":[".modal {\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `content-warning-module__modal___s502s`
};
export default ___CSS_LOADER_EXPORT___;
